import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { StatsStrip } from './components/StatsStrip';
import { PainPoints } from './components/PainPoints';
import { Journey } from './components/Journey';
import { Bands } from './components/Bands';
import { Practice } from './components/Practice';
import { HowItWorks } from './components/HowItWorks';
import { UseCases } from './components/UseCases';
import { Offer } from './components/Offer';
import { Faq } from './components/Faq';
import { ClosingCta } from './components/ClosingCta';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
const PAGE_TITLE = 'KINDERHANDBALL – Mit Plan ins Training | 6 PDF-Bände für 6–12 Jahre';
const PAGE_DESCRIPTION = 'Digitale Praxis-Sammlung für Lehrkräfte und Trainerinnen und Trainer: sechs PDF-Bände mit 360 Seiten Trainingseinheiten für Kinderhandball von 6 bis 12 Jahren.';
export function App() {
  useEffect(() => {
    document.documentElement.lang = 'de';
    document.title = PAGE_TITLE;
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = PAGE_DESCRIPTION;
  }, []);
  return <div className="w-full bg-navy-800 font-sans" data-id="element-0" data-mp="4n5w26l2pak">
      <Hero data-id="element-1" data-mp="2zl3cjn8vpa6d" />
      <main data-id="element-2" data-mp="2zlle8zeb8glo">
        <StatsStrip data-id="element-3" data-mp="2zlv8iz6e19x6" />
        <PainPoints data-id="element-4" data-mp="2zmo4r67q0h12" />
        <Journey data-id="element-5" data-mp="2zn6b4vo3kbmp" />
        <Bands data-id="element-6" data-mp="33mouvo46mgny" />
        <Practice data-id="element-7" data-mp="33m5b01uz1i7a" />
        <HowItWorks data-id="element-8" data-mp="33nq73vwxp979" />
        <UseCases data-id="element-9" data-mp="33n6xr3lcnt4u" />
        <Offer data-id="element-10" data-mp="33orki71fa7s5" />
        <Faq data-id="element-11" data-mp="38lrq6gud18iq" />
        <ClosingCta data-id="element-12" data-mp="38l8hzruihyhw" />
      </main>
      <Footer data-id="element-13" data-mp="38l05i12awv78" />
      <StickyCta data-id="element-14" data-mp="38kgkgbhctqoz" />
    </div>;
}